module.exports = __webpack_public_path__ + "static/media/441878672_3603452746544166_4937775868154099881_n.dae71a71.jpg";